import {EditVerificationRequest} from './edit-verification-request';

export default EditVerificationRequest;